import apiInstance from "api";

export const SubscriptionPlansApiService = {
  // The sellable software catalog — the DefaultPlanCatalog "F2-" SKUs, active
  // only. Narrower than `list()` below, which also returns the six legacy
  // placeholder rows (ids 1-6) that nobody sells.
  // `includeInactive` is for the manage screen only — the quote picker must
  // never offer a deactivated plan.
  softwareCatalog: async ({ includeInactive = false } = {}) => {
    return await apiInstance.get(`/plans/software-catalog`, {
      params: includeInactive ? { includeInactive: true } : {},
    });
  },
  list: async () => {
    return await apiInstance.get(`/plans`);
  },
  create: async (body) => {
    return await apiInstance.post(`/plans`, body);
  },
  update: async (id, body) => {
    return await apiInstance.put(`/plans/${id}`, body);
  },
  remove: async (id) => {
    return await apiInstance.delete(`/plans/${id}`);
  },
};

export default SubscriptionPlansApiService;
